import { solicitar } from '../identidad/cliente-identidad.js'

export interface IndicadoresTablero {
  estudiantesActivos: number
  expedientesAbiertos: number
  pendientesValidacion: number
  enEjecucion: number
  estadoExpediente?: string
  alcance: 'GLOBAL' | 'PROGRAMA' | 'PROPIO'
  rolPrincipal: 'COORDINADOR_GENERAL' | 'COORDINADOR_ASESORES' | 'ASESOR' | 'TITULAR' | 'ESTUDIANTE'
  graficos?: GraficosTablero
}

export interface SerieGraficoTablero {
  nombre: string
  datos: number[]
}

export interface GraficoSeriesTablero {
  categorias: string[]
  series: SerieGraficoTablero[]
}

export interface GraficoSimpleTablero {
  categorias: string[]
  datos: number[]
}

export interface GraficosTablero {
  expedientesPorProgramaEtapa?: GraficoSeriesTablero
  alertasPorTipo?: GraficoSimpleTablero
  evaluacionesPorNivel?: GraficoSimpleTablero
  cargaEstudiantesPorAsesor?: GraficoSimpleTablero
  expedientesPorAsesorEtapa?: GraficoSeriesTablero
  alertasPorAsesor?: GraficoSeriesTablero
  alertasPorEstudiante?: GraficoSeriesTablero
  evaluacionesPorEstudiante?: GraficoSeriesTablero
  seguimientoPendientePorTipo?: GraficoSimpleTablero
  progresoModulosEstudiante?: GraficoSimpleTablero
  autoevaluacionesEstudiante?: GraficoSimpleTablero
  pendientesSeguimientoEstudiante?: GraficoSimpleTablero
  apoyosEstadoTitular?: GraficoSimpleTablero
  evaluacionesMomentoTitular?: GraficoSeriesTablero
  observacionesAbiertasEstudianteTitular?: GraficoSimpleTablero
}

export function consultarTablero(periodoId?: string): Promise<IndicadoresTablero> {
  const consulta = periodoId ? `?periodoId=${encodeURIComponent(periodoId)}` : ''
  return solicitar(`/api/v1/tablero${consulta}`)
}
